module.exports = __webpack_public_path__ + "static/img/equipamiento-six-4.ef32b46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/equipamiento-six-4.jpg
// module id = M9YH
// module chunks = 1